// 图表基本混合

const lineMixin = {
  methods: {
    // 初始化折线图点击事件
    initClickEvent() {
      // 图表区域点击事件
      this.chartInstance.on('click', (params) => {
        let pointData = {}
        switch (params.componentType) {
          // 线条上圆点点击
          case 'series':
            pointData = this.findCurrPointData(params.name, params.seriesName)
            this.pointClick(params, pointData, { x: params.name, y: params.seriesName })
            break
          // 标注点击
          case 'graphic':
            const markerArr = JSON.parse(params.event.target.id)
            pointData = this.findCurrPointData(markerArr.x, markerArr.y)
            this.markerClick(params, pointData, { x: markerArr.x, y: markerArr.y })
            break
        }
      })
      // 图例点击事件
      this.chartInstance.on('legendselectchanged', (params) => {
        this.legendClick(params)
      })
    },
    pointClick(params, pointData, currLineInfo) {
      // console.log('圆点默认参数--', params)
      // console.log('pointData--', pointData)
      // console.log('x轴--', currLineInfo)
      this.$emit('pointClick', params, pointData, currLineInfo)
    },
    markerClick(params, pointData, currLineInfo) {
      // console.log('标注默认参数--', params)
      // console.log('pointData--', pointData)
      // console.log('x轴--', currLineInfo)
      this.$emit('markerClick', params, pointData, currLineInfo)
    },
    legendClick(params) {
      const activateKeys = Object.keys(params.selected).filter((key) => params.selected[key])
      // console.log('图例点击--', params);
      // console.log('目前激活的图例--', activateKeys);
      const filterSerise = this.currSeries.filter((item) => activateKeys.includes(item.name))
      this.$set(this.options, 'series', filterSerise)
      this.addImageMarkers()
      this.$emit('legendClick', params, activateKeys)
      // this.currSeries = []
    },
  },
}

export { lineMixin }
